@if (basdata && searchFilter) {
  <rask-container-block>
    <rask-header class="flex" size="2" underline>{{texts.header}}
      <div class="spacer"></div>
      <div class="save-search-filter-container">
        <rask-action-button aid="buttonSparaSokning" color="primary" (click)="saveSearchParams()" icon="far fa-save">
          {{texts.sparaSokning}}
        </rask-action-button>
        <rask-arbetsorder-spara-sokfilter [sokfilter]="triggerSparaFilter">
        </rask-arbetsorder-spara-sokfilter>
      </div>
    </rask-header>
    @if (sokningar && sokningar.length > 0) {
      <rask-tabs [noActiveTab]="true" [closable]="true" [wrap]="true" (onCloseTab)="confirmDeleteSparadSokning($event)" aid="sokningar" closeIcon="far fa-trash-alt" closeIconColor="error" [useRoute]="false" layout="child">
        @for (sokning of sokningar; track sokning) {
          <rask-tab
            [label]="sokning.namn"
            (onTabSelected)="setSokning(sokning)"
            >
          </rask-tab>
        }
      </rask-tabs>
    }
    <div class="arbetsorder-search-container">
      <div class="container m-0">
        <rask-arbetsorder-search-header-filter [searchFilter]="searchFilter" [basdata]="basdata">
        </rask-arbetsorder-search-header-filter>
        <div class="row">
          <div class="col-12 no-padding">
            <div class="more-filters-control">
              <fieldset>
                <label>
                  {{texts.flerFilter}}
                </label>
                <rask-arbetsorder-search-skoglig-data [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-skoglig-data>
                <rask-arbetsorder-search-arbetsmoment [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-arbetsmoment>
                <rask-arbetsorder-search-status [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-status>
                <rask-arbetsorder-search-tid [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-tid>
                <rask-arbetsorder-search-grot [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-grot>
                <rask-arbetsorder-search-virkeskop [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-virkeskop>
                <rask-arbetsorder-search-matning [searchFilter]="searchFilter" [basdata]="basdata"
                  (visibilityChanged)="onFilterPaneVisibilityChanged($event)">
                </rask-arbetsorder-search-matning>
                <div class="float-end">
                  <div class="float-start">
                    <rask-button aid="buttonSokAo" class="search-button" color="secondary"
                      (click)="performSearchArbetsordrar()">
                      {{texts.sok}}
                    </rask-button>
                  </div>
                  <div class="float-end">
                    <rask-button aid="buttonRensaFilter" color="secondary" (click)="performClearFilter()" negative>
                      {{texts.rensaFilter}}
                    </rask-button>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </rask-container-block>
}
